module.exports = __webpack_public_path__ + "media/img/event/academy_header-5fff42ad7e8c2fe5a7242d383bb1fca4.png";